// extracted by mini-css-extract-plugin
module.exports = {"actions":"auth-buttons_actions__h8Wrz","button":"auth-buttons_button__ke_t3","loginButton":"auth-buttons_loginButton__V9sbL"};